class Omnibus extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productInfo = this.closest('.product-info');
    this.priceElements = this.querySelectorAll('[data-prices-variant-id]');

    if (!this.productInfo || !this.priceElements.length) {
      return;
    }

    this.productInfo.addEventListener('variant:change', (event) => {
      const variantId = event.detail.variant;
      this.updateVisibility(variantId);
    });
  }

  updateVisibility(variantId) {
    if (!variantId) {
      return;
    }

    this.priceElements.forEach((element) => {
      const priceVariantId = element.dataset.pricesVariantId;
      if (String(variantId) === String(priceVariantId)) {
        element.style.display = 'block';
      } else {
        element.style.display = 'none';
      }
    });
  }
}

customElements.define('omnibus-element', Omnibus);

